<template>
  <div class="container about-wrap">
      <h1>{{$ml.with('VueJS').get('AboutTitle')}}</h1>
  </div>
</template>

<script>
  export default {
    name: 'about',
    components: {
    },
    data: () => ({
    }),
    methods: {

    },
    mounted() {
      if (!this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/login'})
      }
    }
  }
</script>